// custom rule will have name 'isPasswordMatch'
import { ValidatorForm } from 'react-material-ui-form-validator';
import { cuitValidator } from '@eeff/shared';

export default () => {
  ValidatorForm.addValidationRule('isValidCuit', (value) => cuitValidator(value));
};
